import type { QueryClient } from '@tanstack/vue-query'

// Domain-action invalidation (ada-app-ui's per-action pattern, ADA-4437): 5-part domain-action
// paths are not covered by the global auto-invalidation (it only handles /resource/{id} REST
// paths), so successful actions refresh the overview's case resources explicitly. An action
// target can surface via any settlement card, hence all three case resources — plus the
// availability GETs behind useDebtActions' gates: a respite, a plan or a payment changes what the
// case still allows, so every mounted gate re-evaluates after any action.
const CASE_RESOURCE_PREFIXES = ['/cases', '/case--debt-collections', '/case--enforcements', '/domain-actions/']

/** Invalidate every query whose path starts with one of the prefixes. */
export function invalidatePathPrefixes(queryClient: QueryClient, prefixes: string[]): Promise<void> {
  return queryClient.invalidateQueries({
    predicate: (query) => {
      const path = query.queryKey[1]
      return typeof path === 'string' && prefixes.some((prefix) => path.startsWith(prefix))
    },
  })
}

export function invalidateCaseResources(queryClient: QueryClient, extraPrefixes: string[] = []): Promise<void> {
  return invalidatePathPrefixes(queryClient, [...CASE_RESOURCE_PREFIXES, ...extraPrefixes])
}
